import { axiosChartInstance } from "config";
import { OrderGroup } from "enums";
import { useAxiosMutation } from "hooks";
import { UseOrderChartResponseItem } from "modules/provider/api";
import { RadiologyChartFormPayload } from "modules/provider/shared";
import { useQueryClient } from "react-query";

type UpdateOrderChartParams = {
  encounterId: string;
  chartCode: string;
  orderType: OrderGroup;
};

function useUpdateOrderChart(params: UpdateOrderChartParams) {
  const { encounterId, orderType } = params;
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["updateOrderChart", params],
    (payload: UseOrderChartResponseItem[]) =>
      axiosChartInstance.put(`v1/order/${encounterId}`, payload, {
        params: { orderType },
      }),
    {
      onSuccess: () => queryClient.invalidateQueries(["orderChart", params]),
    }
  );
}

function useUpdateOrderChartRadiology(params: UpdateOrderChartParams) {
  const { encounterId, orderType } = params;
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["updateOrderChart", params],
    (payload: RadiologyChartFormPayload[]) =>
      axiosChartInstance.put(`v1/order/${encounterId}/radiology`, payload, {
        params: { orderType },
      }),
    {
      onSuccess: () => queryClient.invalidateQueries(["orderChart", params]),
    }
  );
}

export { useUpdateOrderChart, useUpdateOrderChartRadiology };
